import { render } from "./investment-level-panel-placeholder.vue?vue&type=template&id=761abe18&scoped=true&ts=true"
import script from "./investment-level-panel-placeholder.vue?vue&type=script&lang=ts"
export * from "./investment-level-panel-placeholder.vue?vue&type=script&lang=ts"

import "./investment-level-panel-placeholder.vue?vue&type=style&index=0&id=761abe18&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761abe18"]])

export default __exports__